import { Component, ViewChild, OnInit, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ServerlessOAuthConfig, ServerlessOauthService, ApplicationConfigurationService } from '@stg-js-ngx-core/oauth';
import { environment } from '../environments/environment';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from './Services/auth.service';
import { OdataService } from './Services/o-data.service';
import { AuthActions } from './Store/actions';
import { AppState } from './Store/reducers';
import { Store } from '@ngrx/store';
import { uiSelectors } from './Store';
import { AlertService, AlertType } from './Services/Utilities/alert.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    loadApp() {
        console.log('OAuth load completed');
        this.authService.setUserInfo(this.oauth.oauthService.oauthProfile);
        this.appLoad = true;

    }

    @ViewChild('oauth') oauth: any;

    public title = 'angular-starter-project';
    public appLoad = false;
    public logo: string = '/assets/images/TrueData-RGB_Logo Primary.png';
    public isLoading: boolean = false;
    public subscription: Subscription = new Subscription();

    public oauthConfig: ServerlessOAuthConfig = {
        serverless: true,
        clientId: environment.omsConfig.ssoClientId,
        rbacEnabled: false,
        rbacAppName: 'TrueData',
        revalidateAfterMin: 15,
        sessionExpirationAlertInMin: 15,
        longestTimeToLiveHours: 8,
        autoLogoutOnSessionExpired: true,
        logoutUrl: environment.baseUrls.sso + '/closeBrowser.html',
        environmentConfig: environment,
    };

    constructor(
        private router: Router,
        private alertService: AlertService,
        private authService: AuthService,
        private odataService: OdataService,
        private store: Store<AppState>,
        private cdr: ChangeDetectorRef,
        private serverlessOauthService: ServerlessOauthService,
        private applicationConfigurationService: ApplicationConfigurationService
    ) {}
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit(): void {
        
        this.subscription.add(
            this.authService.logout$.subscribe((logout) => {
                if (logout) {
                    this.store.dispatch(AuthActions.clearToken());
                    this.oauth.sessionTimerService.sessionInterupter.stopSession();
                }
            })
        );
        this.subscription.add(
            this.authService.getToken().subscribe(
                (token) => {
                    this.store.dispatch(AuthActions.getTokenSuccess({ token }));
                },
                (error) => {
                    console.error('Error getting token:', error);
                    this.alertService.notify(AlertType.Error, 'Failed to retrieve authentication token.');
                    this.store.dispatch(AuthActions.getTokenFailure({ error }));
                    this.store.dispatch(AuthActions.clearToken());
                }
            )
        );
    }

    ngAfterViewInit(): void {
        this.store.select(uiSelectors.selectLoading).subscribe((isLoading) => {
            this.isLoading = isLoading;
            this.cdr.detectChanges();
        });
    }

}
